const clone = value => JSON.parse(JSON.stringify(value || {}));

const normalizeDate = value => {
  const source = String(value || '');
  if (/^\d{4}-\d{2}-\d{2}$/.test(source)) return source;
  const match = source.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return match ? `${match[3]}-${match[2]}-${match[1]}` : source;
};

export const deliveryMoneyValue = value => {
  const source = String(value || '').replace(/[R$\s]/g, '');
  if (!source) return 0;
  const normalized = source.includes(',')
    ? source.replace(/\./g, '').replace(',', '.')
    : source;
  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : null;
};

const addDays = (dateValue, days, businessDays) => {
  if (!dateValue || !Number(days)) return '';
  const date = new Date(`${dateValue}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '';

  let remaining = Number(days);
  while (remaining > 0) {
    date.setDate(date.getDate() + 1);
    if (!businessDays || ![0, 6].includes(date.getDay())) remaining -= 1;
  }
  return date.toISOString().slice(0, 10);
};

const witnesses = value => {
  const items = Array.isArray(value) ? clone(value).slice(0, 2) : [];
  while (items.length < 2) items.push({});
  return items.map(item => ({
    id: item.id || '',
    name: item.name || '',
    email: item.email || '',
    tipo_pessoa: 3,
  }));
};

export const recalculateDeliveryForm = form => {
  const value = clone(form);
  const total = deliveryMoneyValue(value.valor_comissao_total);
  const deduction = deliveryMoneyValue(value.deducao);
  value.valor_comissao_liquida =
    value.valor_comissao_total && total !== null && deduction !== null
      ? (total - deduction).toFixed(2)
      : '';
  value.data_previsao_escritura = addDays(
    value.data_assinatura,
    value.prazo_escritura,
    value.prazo_type === '1'
  );
  value.testemunhas = witnesses(value.testemunhas);
  return value;
};

export const deliveryFormFromTransaction = transaction => {
  const profile = clone(transaction?.profile);
  return recalculateDeliveryForm({
    prazo_type: profile.prazo_type || profile.tipo_dias || '1',
    recibo_type: profile.recibo_type || profile.reciboType || 'manual',
    data_assinatura: normalizeDate(profile.data_assinatura),
    prazo_escritura: profile.prazo_escritura || profile.prazo || '',
    posvenda_franquia: profile.posvenda_franquia || '0',
    valor_comissao_total: profile.valor_comissao_total || '',
    deducao: profile.deducao || '',
    valor_comissao_liquida: profile.valor_comissao_liquida || '',
    email_check: profile.email_check || profile.emailCheck || '0',
    data_previsao_conclusao_venda:
      profile.data_previsao_conclusao_venda ||
      profile.dataPrevisaoConclusaoVenda ||
      '',
    data_previsao_escritura: normalizeDate(
      profile.data_previsao_escritura || profile.dataPrevisaoEscritura
    ),
    observacao: profile.observacao || '',
    reforco: profile.reforco || '',
    reforco_observacao:
      profile.reforco_observacao || profile.reforcoObservacao || '',
    id_responsavel_chaves:
      profile.id_responsavel_chaves || profile.idResponsavelChaves || '',
    testemunhas: witnesses(profile.testemunhas),
    forma_pagamento: Array.isArray(
      profile.forma_pagamento || profile.formasPagamento
    )
      ? (profile.forma_pagamento || profile.formasPagamento).map(String)
      : String(profile.forma_pagamento || profile.formasPagamento || '')
          .split(',')
          .filter(Boolean),
  });
};

export const deliveryDelayDays = (form, today = new Date()) => {
  if (!form.data_assinatura) return null;
  const signature = new Date(`${form.data_assinatura}T12:00:00`);
  if (Number.isNaN(signature.getTime())) return null;
  const current = new Date(today);
  current.setHours(12, 0, 0, 0);
  return Math.floor((current - signature) / 86400000);
};
